import { render, staticRenderFns } from "./XhDate.vue?vue&type=template&id=f59bc84c&scoped=true"
import script from "./XhDate.vue?vue&type=script&lang=js"
export * from "./XhDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59bc84c",
  null
  
)

export default component.exports